<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
      class="container1"
      scrollable
    >
      <v-card :height="innerHeight" class="overflow-auto">
        <div class="d-flex justify-center pa-2" style="position: relative">
          <div style="max-height: 240px">
            <img
              v-if="dialog"
              :src="item.image_url || item.image_path"
              style="
                max-width: 100%;
                max-height: 240px;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
              @error="onImageError($event, null, '')"
            />
          </div>

          <v-btn
            fab
            x-small
            style="z-index: 9999; position: absolute; top: 8px; right: 8px"
            class="ma-1 close-button"
            @click="$emit('close')"
            ><v-icon small :color="site.color">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <v-row>
            <v-col cols="9" class="py-0 align-center">
              <p class="text-subtitle-1 mb-0 truncate-text">
                {{ item.name }}
              </p>
              <v-chip
                x-small
                color="black"
                dark
                v-if="item.status == 'coming soon'"
              >
                {{ item.status }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-title>

        <v-divider style="opacity: 1; color: black" class="ma-3"></v-divider>
        <v-card-text class="pb-2 pt-0">
          <v-row v-if="item.category_label" class="pb-2">
            <v-col cols="6" class="pa-0">
              <v-list-item class="pa-0">
                <v-list-item-avatar size="30" class="ml-3 mr-3">
                  <v-icon :color="site.color">{{
                    `mdi-${item.category_icon}`
                  }}</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title style="font-size: 10px">{{
                    $t("textCategory")
                  }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.category_label
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <div>
            <p class="text-subtitle-2 mb-0 font-weight-bold mt-0">
              {{ $t("rewardExpiredDate") }}
            </p>
            <p>{{ item.expires_at | convertDate }}</p>
          </div>

          <p class="text-subtitle-2 mb-0 font-weight-bold">
            {{ $t("detail") }}
          </p>
          <div
            class="ql-editor"
            style="height: auto !important"
            v-html="formatHtmlDetail(item.detail)"
          ></div>
          <div v-if="false && list.length > 1">
            <p class="text-subtitle-2 mb-0 font-weight-bold mt-0">
              {{ $t("detailMyLuckyDraw") }}
            </p>
            <v-row class="mt-2">
              <v-col
                class="px-2"
                cols="6"
                sm="4"
                lg="4"
                v-for="(item, index) in list"
                :key="index"
              >
                <div>
                  <v-card
                    class="rounded-lg pa-3 card-container"
                    outlined
                    elevation="1"
                    width="100%"
                    style="border: none"
                    :disabled="
                      item.status == 2 || checkExpiredDate(item.expires_at)
                    "
                  >
                    <div
                      v-if="item.status == 2"
                      class="d-flex justify-center align-center cover-card-disable"
                    >
                      <div class="label">{{ $t("isUsed") }}</div>
                    </div>
                    <div
                      v-else-if="checkExpiredDate(item.expires_at)"
                      class="d-flex justify-center align-center cover-card-disable"
                    >
                      <div class="label">{{ $t("myLuckyDrawExpire") }}</div>
                    </div>

                    <v-img
                      :cover="true"
                      :aspect-ratio="1"
                      width="100%"
                      :lazy-src="require('@/assets/images/image.png')"
                      :src="item.image_path"
                    >
                    </v-img>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions
          class="d-block"
          v-if="item.status == 'active' && item.number_of_items > 0"
        >
          <v-list-item class="grow" style="display: -webkit-box">
            <v-row align="start" justify="space-between">
              <v-col cols="6" class="pl-0 pr-1 d-flex align-start">
                <v-card
                  class="rounded-lg d-flex"
                  outlined
                  width="100%"
                  height="36"
                >
                  <v-col
                    cols="3"
                    class="py-0 d-flex justify-center align-center"
                  >
                    <v-icon
                      dense
                      :color="site.color"
                      @click="decrementQuantity"
                      :disabled="this.quantity <= 1"
                      >mdi-minus</v-icon
                    >
                  </v-col>
                  <v-col cols="6" class="pa-0">
                    <input
                      class="quantity"
                      style="
                        max-width: 100%;
                        height: 36px;
                        text-align: center;
                        border-left: 1px solid #e0e0e0;
                        border-right: 1px solid #e0e0e0;
                        border-top: none;
                        border-bottom: none;
                      "
                      v-model="quantity"
                      readonly
                    />
                  </v-col>
                  <v-col
                    cols="3"
                    class="py-0 d-flex justify-center align-center"
                  >
                    <v-icon
                      dense
                      :color="site.color"
                      @click="incrementQuantity"
                      :disabled="quantity >= item.number_of_items"
                      >mdi-plus</v-icon
                    >
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { formatHtmlDetailDefault } from "../../config/general-function";

export default {
  props: ["item", "dialog", "site", "list"],

  data() {
    return {
      quantity: 1,
    };
  },

  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    incrementQuantity() {
      if (this.quantity < this.item.number_of_items) {
        this.quantity = this.quantity + 1;
      }
    },
    decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity = this.quantity - 1;
      }
    },
    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    checkExpiredDate(expireDate) {
      if (!expireDate) return false;
      return moment().startOf("day").isAfter(moment(expireDate).startOf("day"));
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      return height - 100;
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    convertDate(value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 100%;
}
</style>

<style scoped>
.bottomleft {
  position: absolute;
  bottom: 8px;
  left: 16px;
  font-size: 18px;
}
.empty {
  opacity: 1;
}
.cover-card-disable {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.cover-card-disable .label {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  border-radius: 16px;
  background-color: #ffffff;
  padding: 0px 8px;
  /* margin: 0px 0px 72px 0px; */
  width: 75%;
  text-align: center;
}
</style>
